module.exports = __webpack_public_path__ + "static/media/work_with_employers_icon.12b1b719.svg";